import { useLocation } from 'react-router-dom';

// Dynamic route params are ids (MongoDB ObjectIds for insights/predictions,
// numeric ids for events) and must be excluded from the page id.
const OBJECT_ID_REGEX = /^[a-f\d]{24}$/i;

const isIdSegment = (segment: string): boolean =>
    OBJECT_ID_REGEX.test(segment) || /^\d+$/.test(segment);

/**
 * Builds a stable `data-pageid` from the uri part after the hash, used by
 * test automation. Id segments are dropped and the rest are joined with '_':
 *   '/country_graph' -> 'country_graph'
 *   '/risk_intelligence/insights/6a1ee63f8a87565e288e76e1' -> 'risk_intelligence_insights'
 */
const getPageIdFromPathname = (pathname: string): string =>
    pathname
        .split('/')
        .filter(Boolean)
        .filter((segment) => !isIdSegment(segment))
        .join('_');

const usePageId = (): string => {
    const location = useLocation();
    return getPageIdFromPathname(location.pathname);
};

export default usePageId;
